import { useCallback, useContext } from 'react';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { SearchLoadingDispatchContext, SearchResultsDispatchContext } from '@/containers/WorkspaceGlobalSearch/Context';
import type { WorkspaceSearchFull } from '@trinity/chat';

export default function useSearchFetchProjects() {
  const setResults = useContext(SearchResultsDispatchContext);
  const setLoading = useContext(SearchLoadingDispatchContext);

  const apiClient = useChatApiClient();

  const projects = useCallback(async ({ filters, size }: FetchData) => {
    const result = await apiClient.workspacesGlobalSearch.projects({
      filters,
      size,
    });

    if (result) {
      setResults(prev => ({
        ...prev,
        projects: result,
      }));
    }
  }, [apiClient, setResults]);

  const fetch = useCallback(({ filters, size }: FetchData) => {
    setLoading(prev => ({ ...prev, projects: { ...prev.projects, loading: true } }));
    Promise.all([
      new Promise<void>(resolve => setTimeout(() => resolve(), 250)),
      projects({ filters, size }),
    ])
      .then(() => {
        setLoading(prev => ({ ...prev, projects: { loading: false } }));
      });
  }, [projects, setLoading]);

  return fetch;
}

export { useSearchFetchProjects };

type FetchData = {
  filters: WorkspaceSearchFull.Project.Filters;
  size: number;
};